export default __webpack_public_path__ + "static/media/readme.b80d57e2.md";